var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgColorsMinor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "M13.676 9.585c.494-.56.754-1.287.724-2.033V7.43a6.4 6.4 0 0 0-3.951-5.349 6.42 6.42 0 0 0-6.576 1.035A6.4 6.4 0 0 0 1.76 9.419a6.4 6.4 0 0 0 4.625 4.78c.846.153 1.705.22 2.565.199h.737c.24 0 .47-.125.631-.303a.94.94 0 0 0 .242-.652.96.96 0 0 0-.96-.96 1 1 0 0 1-.689-.288.96.96 0 0 1 .68-1.64h2.155a2.9 2.9 0 0 0 1.93-.97M9.28 3.837a.96.96 0 1 1-1.92 0 .96.96 0 0 1 1.92 0m-4.16 2.24a.96.96 0 1 0 0-1.92.96.96 0 0 0 0 1.92m-.64 3.2a.96.96 0 1 0 0-1.92.96.96 0 0 0 0 1.92m6.4-2.56a.96.96 0 1 0 0-1.92.96.96 0 0 0 0 1.92",
  clipRule: "evenodd"
})));
export default SvgColorsMinor;